/* istanbul ignore file */
/* tslint:disable */

export enum AssignmentTypesEnum {
  PROJECT = 'project',
  PROPOSAL = 'proposal',
  JOB = 'job',
}
